import useLadyService from '@/services/LadyService';
import './citySlider.scss';
import { useRef, useCallback, useEffect, useState, useMemo } from 'react';
import { Icon, Select } from '@/components/ui';
import { useDispatch, useSelector } from 'react-redux';
import { getCountriesData } from '@/stores/slices/userSlice';
import { useActiveCountry } from '../ui/select/SelectCountry';

const locations_sk = [
    { id: 44, slug: 'banska-bystrica', country_id: 33, highlight: 0, sort: 1 },
    { id: 39, slug: 'bratislava', country_id: 33, highlight: 2, sort: 2 },
    { id: 59, slug: 'dunajska-streda', country_id: 33, highlight: 0, sort: 3 },
    { id: 55, slug: 'galanta', country_id: 33, highlight: 0, sort: 4 },
    { id: 61, slug: 'humenne', country_id: 33, highlight: 0, sort: 5 },
    { id: 62, slug: 'komarno', country_id: 33, highlight: 0, sort: 6 },
    { id: 40, slug: 'kosice', country_id: 33, highlight: 1, sort: 7 },
    { id: 66, slug: 'kysucke-nove-mesto', country_id: 33, highlight: 0, sort: 8 },
    { id: 50, slug: 'levice', country_id: 33, highlight: 0, sort: 9 },
    { id: 51, slug: 'liptovsky-mikulas', country_id: 33, highlight: 0, sort: 10 },
    { id: 63, slug: 'lucenec', country_id: 33, highlight: 0, sort: 11 },
    { id: 56, slug: 'malacky', country_id: 33, highlight: 0, sort: 12 },
    { id: 47, slug: 'martin', country_id: 33, highlight: 0, sort: 13 },
    { id: 53, slug: 'michalovce', country_id: 33, highlight: 0, sort: 14 },
    { id: 41, slug: 'nitra', country_id: 33, highlight: 1, sort: 15 },
    { id: 64, slug: 'nove-mesto-nad-vahom', country_id: 33, highlight: 0, sort: 16 },
    { id: 65, slug: 'nove-zamky', country_id: 33, highlight: 0, sort: 17 },
    { id: 67, slug: 'partizanske', country_id: 33, highlight: 0, sort: 18 },
    { id: 57, slug: 'pezinok', country_id: 33, highlight: 0, sort: 19 },
    { id: 48, slug: 'piestany', country_id: 33, highlight: 0, sort: 20 },
    { id: 52, slug: 'poprad', country_id: 33, highlight: 0, sort: 21 },
    { id: 43, slug: 'presov', country_id: 33, highlight: 1, sort: 22 },
    { id: 54, slug: 'prievidza', country_id: 33, highlight: 0, sort: 23 },
    { id: 68, slug: 'sala', country_id: 33, highlight: 0, sort: 24 },
    { id: 58, slug: 'senica', country_id: 33, highlight: 0, sort: 25 },
    { id: 60, slug: 'topolcany', country_id: 33, highlight: 0, sort: 26 },
    { id: 46, slug: 'trencin', country_id: 33, highlight: 1, sort: 27 },
    { id: 42, slug: 'trnava', country_id: 33, highlight: 1, sort: 28 },
    { id: 49, slug: 'zilina', country_id: 33, highlight: 1, sort: 29 },
    { id: 45, slug: 'zvolen', country_id: 33, highlight: 0, sort: 30 },
    { id: 69, slug: 'snina', country_id: 33, highlight: 0, sort: 31 },
];

const locations_cz = [
    { id: 1, slug: 'prague', country_id: 1, highlight: 2, sort: 1 },
    { id: 2, slug: 'mlada-boleslav', country_id: 1, highlight: 0, sort: 2 },
    { id: 3, slug: 'kolin', country_id: 1, highlight: 0, sort: 3 },
    { id: 4, slug: 'kladno', country_id: 1, highlight: 0, sort: 4 },
    { id: 5, slug: 'podebrady', country_id: 1, highlight: 0, sort: 5 },
    { id: 6, slug: 'beroun', country_id: 1, highlight: 0, sort: 6 },
    { id: 7, slug: 'pilsen', country_id: 1, highlight: 1, sort: 7 },
    { id: 8, slug: 'czech-budejovice', country_id: 1, highlight: 1, sort: 8 },
    { id: 9, slug: 'karlovy-vary', country_id: 1, highlight: 1, sort: 9 },
    { id: 10, slug: 'jihlava', country_id: 1, highlight: 1, sort: 10 },
    { id: 11, slug: 'tabor', country_id: 1, highlight: 0, sort: 11 },
    { id: 12, slug: 'domazhlice', country_id: 1, highlight: 0, sort: 12 },
    { id: 13, slug: 'klatovy', country_id: 1, highlight: 0, sort: 13 },
    { id: 14, slug: 'hradec-kralove', country_id: 1, highlight: 1, sort: 14 },
    { id: 15, slug: 'pardubice', country_id: 1, highlight: 1, sort: 15 },
    { id: 16, slug: 'liberec', country_id: 1, highlight: 1, sort: 16 },
    { id: 17, slug: 'usti-nad-labem', country_id: 1, highlight: 1, sort: 17 },
    { id: 18, slug: 'teplice', country_id: 1, highlight: 0, sort: 18 },
    { id: 19, slug: 'ceska-lipa', country_id: 1, highlight: 0, sort: 19 },
    { id: 20, slug: 'most', country_id: 1, highlight: 0, sort: 20 },
    { id: 21, slug: 'cheb', country_id: 1, highlight: 0, sort: 21 },
    { id: 22, slug: 'trutnov', country_id: 1, highlight: 0, sort: 22 },
    { id: 23, slug: 'brno', country_id: 1, highlight: 1, sort: 23 },
    { id: 24, slug: 'olomouc', country_id: 1, highlight: 1, sort: 24 },
    { id: 25, slug: 'ostrava', country_id: 1, highlight: 1, sort: 25 },
    { id: 26, slug: 'zlin', country_id: 1, highlight: 1, sort: 26 },
    { id: 27, slug: 'uherske-hradiste', country_id: 1, highlight: 0, sort: 27 },
    { id: 28, slug: 'prostejov', country_id: 1, highlight: 0, sort: 28 },
    { id: 29, slug: 'prerov', country_id: 1, highlight: 0, sort: 29 },
    { id: 30, slug: 'znojmo', country_id: 1, highlight: 0, sort: 30 },
    { id: 31, slug: 'svitavy', country_id: 1, highlight: 0, sort: 31 },
    { id: 35, slug: 'nymburk', country_id: 1, highlight: 0, sort: 32 },
    { id: 36, slug: 'opava', country_id: 1, highlight: 0, sort: 33 },
    { id: 37, slug: 'jablonec-nad-nisou', country_id: 1, highlight: 0, sort: 34 },
    { id: 38, slug: 'pi­sek', country_id: 1, highlight: 0, sort: 35 },
];

const locations = [
    { id: 1, slug: 'prague', country_id: 1, highlight: 2, sort: 1 },
    { id: 2, slug: 'mlada-boleslav', country_id: 1, highlight: 0, sort: 2 },
    { id: 3, slug: 'kolin', country_id: 1, highlight: 0, sort: 3 },
    { id: 4, slug: 'kladno', country_id: 1, highlight: 0, sort: 4 },
    { id: 5, slug: 'podebrady', country_id: 1, highlight: 0, sort: 5 },
    { id: 6, slug: 'beroun', country_id: 1, highlight: 0, sort: 6 },
    { id: 7, slug: 'pilsen', country_id: 1, highlight: 1, sort: 7 },
    { id: 8, slug: 'czech-budejovice', country_id: 1, highlight: 1, sort: 8 },
    { id: 9, slug: 'karlovy-vary', country_id: 1, highlight: 1, sort: 9 },
    { id: 10, slug: 'jihlava', country_id: 1, highlight: 1, sort: 10 },
    { id: 11, slug: 'tabor', country_id: 1, highlight: 0, sort: 11 },
    { id: 12, slug: 'domazhlice', country_id: 1, highlight: 0, sort: 12 },
    { id: 13, slug: 'klatovy', country_id: 1, highlight: 0, sort: 13 },
    { id: 14, slug: 'hradec-kralove', country_id: 1, highlight: 1, sort: 14 },
    { id: 15, slug: 'pardubice', country_id: 1, highlight: 1, sort: 15 },
    { id: 16, slug: 'liberec', country_id: 1, highlight: 1, sort: 16 },
    { id: 17, slug: 'usti-nad-labem', country_id: 1, highlight: 1, sort: 17 },
    { id: 18, slug: 'teplice', country_id: 1, highlight: 0, sort: 18 },
    { id: 19, slug: 'ceska-lipa', country_id: 1, highlight: 0, sort: 19 },
    { id: 20, slug: 'most', country_id: 1, highlight: 0, sort: 20 },
    { id: 21, slug: 'cheb', country_id: 1, highlight: 0, sort: 21 },
    { id: 22, slug: 'trutnov', country_id: 1, highlight: 0, sort: 22 },
    { id: 23, slug: 'brno', country_id: 1, highlight: 1, sort: 23 },
    { id: 24, slug: 'olomouc', country_id: 1, highlight: 1, sort: 24 },
    { id: 25, slug: 'ostrava', country_id: 1, highlight: 1, sort: 25 },
    { id: 26, slug: 'zlin', country_id: 1, highlight: 1, sort: 26 },
    { id: 27, slug: 'uherske-hradiste', country_id: 1, highlight: 0, sort: 27 },
    { id: 28, slug: 'prostejov', country_id: 1, highlight: 0, sort: 28 },
    { id: 29, slug: 'prerov', country_id: 1, highlight: 0, sort: 29 },
    { id: 30, slug: 'znojmo', country_id: 1, highlight: 0, sort: 30 },
    { id: 31, slug: 'svitavy', country_id: 1, highlight: 0, sort: 31 },
    { id: 34, slug: 'london', country_id: 2, highlight: 1, sort: 1 },
    { id: 35, slug: 'nymburk', country_id: 1, highlight: 0, sort: 32 },
    { id: 36, slug: 'opava', country_id: 1, highlight: 0, sort: 33 },
    { id: 37, slug: 'jablonec-nad-nisou', country_id: 1, highlight: 0, sort: 34 },
    { id: 38, slug: 'pi­sek', country_id: 1, highlight: 0, sort: 35 },
    { id: 39, slug: 'bratislava', country_id: 33, highlight: 2, sort: 1 },
    { id: 40, slug: 'kosice', country_id: 33, highlight: 1, sort: 2 },
    { id: 41, slug: 'nitra', country_id: 33, highlight: 1, sort: 3 },
    { id: 42, slug: 'trnava', country_id: 33, highlight: 1, sort: 4 },
    { id: 43, slug: 'presov', country_id: 33, highlight: 1, sort: 5 },
    { id: 44, slug: 'banska-bystrica', country_id: 33, highlight: 0, sort: 6 },
    { id: 45, slug: 'zvolen', country_id: 33, highlight: 0, sort: 7 },
    { id: 46, slug: 'trencin', country_id: 33, highlight: 1, sort: 8 },
    { id: 47, slug: 'martin', country_id: 33, highlight: 0, sort: 9 },
    { id: 48, slug: 'piestany', country_id: 33, highlight: 0, sort: 10 },
    { id: 49, slug: 'zilina', country_id: 33, highlight: 1, sort: 11 },
    { id: 50, slug: 'levice', country_id: 33, highlight: 0, sort: 12 },
    { id: 51, slug: 'liptovsky-mikulas', country_id: 33, highlight: 0, sort: 13 },
    { id: 52, slug: 'poprad', country_id: 33, highlight: 0, sort: 14 },
    { id: 53, slug: 'michalovce', country_id: 33, highlight: 0, sort: 15 },
    { id: 54, slug: 'prievidza', country_id: 33, highlight: 0, sort: 16 },
    { id: 55, slug: 'galanta', country_id: 33, highlight: 0, sort: 17 },
    { id: 56, slug: 'malacky', country_id: 33, highlight: 0, sort: 18 },
    { id: 57, slug: 'pezinok', country_id: 33, highlight: 0, sort: 19 },
    { id: 58, slug: 'senica', country_id: 33, highlight: 0, sort: 20 },
    { id: 59, slug: 'dunajska-streda', country_id: 33, highlight: 0, sort: 21 },
    { id: 60, slug: 'topolcany', country_id: 33, highlight: 0, sort: 21 },
    { id: 61, slug: 'humenne', country_id: 33, highlight: 0, sort: 22 },
    { id: 62, slug: 'komarno', country_id: 33, highlight: 0, sort: 23 },
    { id: 63, slug: 'lucenec', country_id: 33, highlight: 0, sort: 24 },
    { id: 64, slug: 'nove-mesto-nad-vahom', country_id: 33, highlight: 0, sort: 25 },
    { id: 65, slug: 'nove-zamky', country_id: 33, highlight: 0, sort: 26 },
    { id: 66, slug: 'kysucke-nove-mesto', country_id: 33, highlight: 0, sort: 27 },
    { id: 67, slug: 'partizanske', country_id: 33, highlight: 0, sort: 28 },
    { id: 68, slug: 'sala', country_id: 33, highlight: 0, sort: 30 },
    { id: 69, slug: 'snina', country_id: 33, highlight: 0, sort: 31 },
];

const COUNTRY_LOCATIONS = {
    cz: {
        countryId: 1,
        displayOrder: locations_cz,
    },
    sk: {
        countryId: 33,
        displayOrder: locations_sk,
    },
};

const CitySlider = () => {
    const { t, navigate, lang } = useLadyService();
    const dispatch = useDispatch();
    const countriesData = useSelector(getCountriesData);
    // const toggleCountry = useToggleCountry()
    const activeCountry = useActiveCountry();



    // [{ cz: {...} }, { sk: {...} }] -> [{ code: 'cz', country: {...} }, ...]
    const countryEntries = useMemo(() => countriesData?.length
        ? countriesData.flatMap((item) => Object.entries(item))
        : [], [countriesData])


    const country_options = useMemo(() => countryEntries.map(([code, country]) => ({
        value: code ?? 'cz',
        title: country.name ?? 'Czechia',
        icon: ` icon-flag ${code.toUpperCase() ?? 'CZ'}`,
        ads: country.profiles_count ?? 0
    })), [countryEntries]);

    const [selectedCountry, setSelectedCountry] = useState(() => {
        const fromUrl = country_options.find((o) => o.value === activeCountry?.code);
        return fromUrl
            ?? country_options[0]
            ?? { value: 'cz', title: 'Czechia', icon: ' icon-flag CZ', ads: 0 };
    });


    useEffect(() => {
        const code = activeCountry?.code;
        // Sync only when the URL's country actually changes — so
        // - data (re)loads don't wipe the user's manual dropdown choice,
        // - clicking a city in the slider (which navigates) updates the flag.
        if (!code) return;
        const option = country_options.find((o) => o.value === code);
        if (option) setSelectedCountry(option);
    }, [activeCountry?.code, country_options]);

    const calculateStyle = (spriteIndex, city, code) => {
        const classes = `city-${city.slug} country_${code}`;

        // No matching image in the original country-specific sprite order.
        if (spriteIndex < 0) {
            return { styles: {}, classes };
        }

        const cols = 10;
        const rows = 3;
        const spriteW = 2000;
        const spriteH = 450;

        const cellW = spriteW / cols;
        const cellH = spriteH / rows;

        const col = spriteIndex % cols;
        const row = Math.floor(spriteIndex / cols);

        const posX = col * cellW;
        const posY = row * cellH + 20;

        return {
            classes,
            styles: {
                backgroundPosition: `-${posX.toFixed(2)}px -${posY.toFixed(2)}px`,
            },
        };
    };

    const cities = useMemo(() => {
        const code = selectedCountry?.value ?? 'cz';

        const apiCities = countryEntries.find(
            ([countryCode]) => countryCode === code
        )?.[1]?.cities ?? [];

        const config = COUNTRY_LOCATIONS[code];

        // Graceful fallback for countries without a configured sprite.
        if (!config) {
            return apiCities.map((city) => ({
                ...city,
                ...calculateStyle(-1, city, code),
            }));
        }

        // Display order: locations_cz or locations_sk.
        const displayOrderBySlug = new Map(
            config.displayOrder.map((location, index) => [
                location.slug,
                index,
            ])
        );

        // Sprite order: original locations array, filtered by country.
        // Filtering is important because London is inserted between CZ locations.
        const spriteIndexBySlug = new Map(
            locations
                .filter((location) => location.country_id === config.countryId)
                .map((location, index) => [
                    location.slug,
                    index,
                ])
        );

        const getDisplayOrder = (city) =>
            displayOrderBySlug.get(city.slug) ?? Number.MAX_SAFE_INTEGER;

        return [...apiCities]
            .sort((a, b) => getDisplayOrder(a) - getDisplayOrder(b))
            .map((city) => {
                const spriteIndex = spriteIndexBySlug.get(city.slug) ?? -1;

                return {
                    ...city,
                    ...calculateStyle(spriteIndex, city, code),
                };
            });
    }, [countryEntries, selectedCountry?.value]);

    const setCountry = (value) => {
        const found = country_options.find((i) => i?.value === value);
        setSelectedCountry(found ?? { value: '', title: '-', icon: '-' });
        const entry = countryEntries.find(([code]) => code === value);
        const slug = entry?.[1]?.slug || value;
        navigate(`/${lang}/${slug}`);
    };

    const handleCityChange = (slug) => navigate(`/${lang}/${slug}`);

    const trackRef = useRef(null);
    const [edges, setEdges] = useState({ start: true, end: false });
    const [visibleCities, setVisibleCities] = useState([]);

    const updateEdges = useCallback(() => {
        const el = trackRef.current;
        if (!el) return;

        const max = el.scrollWidth - el.clientWidth;

        setEdges({
            start: el.scrollLeft <= 1,
            end: el.scrollLeft >= max - 1,
        });

        const left = el.getBoundingClientRect().left + el.clientLeft;
        const right = left + el.clientWidth;

        const cards = el.querySelectorAll('.city--item:not(.country-block)');

        const visible = Array.from(cards).flatMap((card, index) => {
            const rect = card.getBoundingClientRect();
            const visibleWidth = Math.max(
                0,
                Math.min(rect.right, right) - Math.max(rect.left, left)
            );

            return visibleWidth >= rect.width / 2 ? [index] : [];
        });

        setVisibleCities(visible);
    }, []);

    const scrollToCity = (index) => {
        const el = trackRef.current;
        const card = el?.querySelectorAll(
            '.city--item:not(.country-block)'
        )[index];

        if (!card) return;

        // Center the selected card in the slider.
        const left =
            el.scrollLeft +
            card.getBoundingClientRect().left -
            (el.getBoundingClientRect().left + el.clientLeft) -
            (el.clientWidth - card.offsetWidth) / 2;

        el.scrollTo({ left, behavior: 'smooth' });
    };

    useEffect(() => {
        const el = trackRef.current;
        if (!el) return;

        updateEdges();
        el.addEventListener('scroll', updateEdges, { passive: true });
        window.addEventListener('resize', updateEdges);

        return () => {
            el.removeEventListener('scroll', updateEdges);
            window.removeEventListener('resize', updateEdges);
        };
    }, [updateEdges, cities]);

    const scrollByPage = (direction) => {
        const el = trackRef.current;
        el?.scrollBy({ left: direction * el.clientWidth, behavior: 'smooth' });
    };

    return (
        <>
            <div className='cities-wrapper'>
                <button
                    className="cities-slider__arrow button button--secondary cities-slider__arrow--prev"
                    onClick={() => scrollByPage(-1)}
                    disabled={edges.start}
                    aria-label="Previous cities"
                >
                    ‹
                </button>
                <ul className="cities" ref={trackRef}>
                    <li className={`city--item country-block`}>
                        <Select
                            name={'country_select'}
                            onChange={setCountry}
                            options={country_options}
                            arrowSize={'m'}
                            withoutTitle={true}
                            withIcon={true}
                            defaulTitle={t('country')}
                            clazzWrapper={'select-field m-h-8'}
                            controlledValue={selectedCountry?.value}
                            controlledTitle={selectedCountry?.title}
                            controlledIcon={selectedCountry?.icon}
                            clazzSvg={'color-green'}
                        />
                        <hr />
                        <div className='city--info'>
                            <span className='title_h3'>
                                {`${t('active')} ${t('profiles')}: `}
                            </span>
                            <b className='d-flex align-center gap-8'><Icon spritePath='pants' clazz='color-main' />{selectedCountry?.ads}</b>
                        </div>
                    </li>
                    {cities.map(({ slug, name, profiles_count, classes, styles }, i) => (
                        <li key={`${slug}-${i}`} className={`city--item cursor-pointer`} onClick={() => handleCityChange(slug)}>
                            <div style={styles} className={`img-placeholder city ${classes}`} />
                            <div className='city--info'>
                                <span className='title_h3'>
                                    {name}
                                </span>
                                <p className='small'>
                                    <Icon spritePath='pants' clazz='color-main' />
                                    {profiles_count}
                                    {/* {t('profiles')} */}
                                </p>
                            </div>
                        </li>
                    ))}

                </ul>
                <button
                    className="cities-slider__arrow button button--secondary cities-slider__arrow--next"
                    onClick={() => scrollByPage(1)}
                    disabled={edges.end}
                    aria-label="Next cities"
                >
                    ›
                </button>
            </div>
            <div className="cities--pagination">
                {cities.map((city, index) => (
                    <span
                        onClick={() => scrollToCity(index)}
                        key={`city-dot-${city.slug}-${index}`}
                        className={`pagination-dot ${visibleCities.includes(index) ? 'active' : ''
                            }`}
                    />
                ))}
            </div>
        </>


    )
};

export default CitySlider;